module.exports = __webpack_public_path__ + "static/iso-logo-afdf2c604d2fe503ab0ba2c32e567b1c.png";